var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.159,
    height: 27.157,
    viewBox: "0 0 27.159 27.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-pencil-6462029",
    transform: "translate(-151.76 -151.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16680",
    "data-name": "Path 16680",
    d: "M157.07,347.6h-5.31v-5.31a2.269,2.269,0,0,1,.666-1.606L167.4,325.707l6.251,6.251-14.971,14.971a2.273,2.273,0,0,1-1.606.666Z",
    transform: "translate(0 -168.66)",
    fill: "#2c53bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16681",
    "data-name": "Path 16681",
    d: "M721.73,152.59l2.326,2.326a2.778,2.778,0,0,1,0,3.926l-3.038,3.038-6.251-6.251,3.038-3.038a2.778,2.778,0,0,1,3.926,0Z",
    transform: "translate(-545.95 0)",
    fill: "#2c53bb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.e459be3cb94118a0e8d6812cab680e9c.svg";
export { ForwardRef as ReactComponent };